import { useCacheSlice } from "../hooks";

export type { ReportsData, ReportsPerson } from "./reportsData";

export function useReportsCache() {
	const { data, isLoading } = useCacheSlice("reports");
	const reports = data;
	return { reports, isLoading };
}
